import { z } from 'zod'

const codeIsNumbers = (code: string) => /^\d{6}$/.test(code)

export const codeValidation = z.string().refine(codeIsNumbers, {
  message: 'The code entered should be 6 digits',
})

// Corporate mail scanners rewrite emailed links, appending tracking text or
// whitespace to the code param — recover the code rather than letting Cognito
// reject the mangled value with an error the user can't act on. See SD-3409.
// Anchored because the generated link puts the code first (`?token=<code>&...`),
// so digits in appended scanner metadata can never be mistaken for it.
// Coerces only, so codeValidation above still rejects an unrecoverable code.
export const sanitiseAuthCodeParam = (code?: string | null): string | undefined =>
  /^\s*(\d{6})(?!\d)/.exec(code ?? '')?.[1] || code?.trim() || undefined
